<template>
  <div class="app-container">
    <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :label-width="'115px'" :get-action="queryApi" :serial="serial" :selection="selection" :before-reset-search="beforeResetSearch" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <BjSelectLov v-model="queryParams.cusId" :option-list="customerList" :placeholder="$t('customerNameText')" />
        </el-col>
      </template>
      <template v-slot:tableOperation>
        <el-col :span="colSpan">
          <el-button type="primary" class="main-btn" @click="onExport">{{ $t('exportText') }}</el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="scope">
              <template v-if="false" />
              <template v-else-if="col.prop == 'cusId'">{{ customerList.bjGet(scope.row.cusId) }}</template>
              <span v-else>{{ scope.row[col.prop] }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" align="center">
            <template slot-scope="props">
                <el-button type="text" class="edit-btn" @click="onIN(props.row,'onIN')">{{ $t('billingPage.PalletchangeIN') }}</el-button>
                <el-button type="text" class="edit-btn" @click="onOUT(props.row,'onOUT')">{{ $t('billingPage.PalletchangeOUT') }}</el-button>
                <el-button type="text" class="edit-btn" @click="onLog(props.row)">{{ $t('RoleManagement.common.Log') }}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>

    <DataForm ref="DataForm" @reFresh="reFresh"></DataForm>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { userApi } from '@/api';
import BjSelectCustomer from '@/components/BjSelectCustomer/index.vue';
import papa from 'papaparse';
import DataForm from "./copponents/DataForm.vue"
import orderLog from '@/utils/log.js';

export default {
  name: 'BusinessStockUserCsg',
  components: { BjSelectCustomer, DataForm },
  mixins: [pageMiXin],
  data() {
    return {
      queryApi: userApi.getCustomerPalletPageList,
      colSpan: 4,
      // 查询参数
      queryParams: {
        cusId: null,
      },
      labelList: [
        { label: this.$t('billingPage.CustomerName'), prop: 'cusId', isCheck: true, disabled: false },
        { label: this.$t('billingPage.WoodenStandardQty'), prop: 'standardPallet', isCheck: true, disabled: false },
        { label: this.$t('billingPage.ChepPalletQty'), prop: 'chepPallet', isCheck: true, disabled: false },
        { label: this.$t('billingPage.LoscamPalletQty'), prop: 'loscomPallet', isCheck: true, disabled: false },
        { label: this.$t('billingPage.CSGPalletQty'), prop: 'csgPallet', isCheck: true, disabled: false },
        { label: this.$t('billingPage.CBM'), prop: 'cbm', isCheck: true, disabled: false },
        { label: this.$t('billingPage.customerPallet'), prop: 'customerPallet', isCheck: true, disabled: false },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 270 },
        // { label: 'BusinessStockSearch.table.stockNum2', prop: 'stockNum', isCheck: true, disabled: false },
      ],
    };
  },
  methods: {
    onIN(row,value){
      this.$refs.DataForm.show(row,value);
    },
    onOUT(row,value){
      this.$refs.DataForm.show(row,value);
    },
    onLog(row){
      orderLog(
          this.$BjDialogListConfig['purchaseDefault'](`${this.$t('BusinessPurchaseApplyDetail.dialogText2')}`, {
              actionApi: userApi.getCustomerPalletLog,
              defaultQuery: {
                cusId: row.cusId
              },
              columns: [
                  {
                      prop: 'operationName',
                      label: 'BjDialogListConfig.Operator',
                  },
                  {
                      prop: 'creationDate',
                      label: 'BjDialogListConfig.Operationtime',
                  },
                  {
                      prop: 'operation',
                      label: 'BjDialogListConfig.Remarks',
                  },
              ],
          }),
      );
    },
    onExport() {
      const fileName = `Customer Pallet`;
      if (!this.selectedRows.length) {
        this.$message.warning(this.$t('ThreePartySalesOrder.selectDataWarning'));
        return;
      }
      let csvData = [];
      this.selectedRows.forEach(async (item) => {
        csvData.push({
          'Customer Name': this.customerList.bjGet(item.cusId),
          'Standard Pallet Qty': item.standardPallet,
          'Chep Pallet Qty': item.chepPallet,
          'Loscam Pallet Qty': item.loscomPallet,
          'CSG Pallet Qty': item.csgPallet,
          "CBM":item.cbm,
          "customerPallet":item.customerPallet
        });
      });

      setTimeout(() => {
        if (!csvData.length) return;
        const csv = papa.unparse(csvData);
        const data = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const csvURL = window.URL.createObjectURL(data);
        const download = document.createElement('a');
        download.href = csvURL;
        download.setAttribute('download', fileName);
        download.click();
        csvData = null;
      }, 1000);
    },
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParams = {
        cusId: null,
      };

      return new Promise(resolve => {
        resolve();
      });
    },
  },
};
</script>
<style scoped>
::v-deep .bj-page .el-form-item__label {
  display: none;
}
</style>
